import React from "react";

/** Outline SIM-card glyph used as the BlueRoam brand mark.
 *  Square-ish card with a clipped top-right corner and the classic chip contacts inside. */
export default function SimCardIcon({ size = 18, className = "", stroke = "currentColor" }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      className={className}
      fill="none"
      stroke={stroke}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {/* card outline with clipped top-right */}
      <path d="M5 4h9l5 5v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" />
      {/* chip window */}
      <rect x="7" y="11" width="10" height="7" rx="1.2" />
      {/* chip traces */}
      <path d="M7 14.5h3.2" />
      <path d="M13.8 14.5H17" />
      <path d="M10.2 11v7" />
      <path d="M13.8 11v7" />
    </svg>
  );
}
